import module from 'empresa/module.js'
import template from './template.html'

export class EmpresasAgregarSeleccionarComponent {
  mostrarCirculo = true
  archivo = null
  imagen = null
  avatar = null
  resultado = {exito: false}
  seleccionar = false
  onClose

  constructor ($scope) {
    this.$scope = $scope
  }

  aceptar () {
    let file = this.codificar(this.avatar, this.archivo.name)
    this.resultado.img = file
    this.seleccionar = false
    this.resultado.exito = true

    this.onClose({$event: {detail: this.resultado}})
  }

  cancelar () {
    this.seleccionar = false
    this.onClose({$event: {detail: this.resultado.exito}})
  }

  codificar (dataURI, filename) {
    let byteString = atob(dataURI.split(',')[1])// convert base64 to raw binary data held in a string
    let mimeString = dataURI.split(',')[0].split(':')[1].split('')[0] // separate out the mime component
    let arrayBuffer = new ArrayBuffer(byteString.length) // write the bytes of the string to an ArrayBuffer
    let _ia = new Uint8Array(arrayBuffer)

    for (let i = 0; i < byteString.length; i++) {
      _ia[i] = byteString.charCodeAt(i)
    }

    return new File([new DataView(arrayBuffer)], filename, {type: mimeString})
  }

  decodificar () {
    this.imagen = null

    if (!this.archivo)
      return

    this.seleccionar = true
    let reader = new global.FileReader()
    reader.readAsDataURL(this.archivo)
    reader.onload = (event) => {
      this.$scope.$apply(() => {
        this.imagen = event.target.result
      })
    }
    reader.onError = (event) => {
      console.error('error ' + event.target.error.code)
    }
  }
}

module.component('empresasAgregarSeleccionar', {
  controller: EmpresasAgregarSeleccionarComponent,
  template,
  bindings: {
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresas/components/agregar/seleccionar/component.js